// extracted by mini-css-extract-plugin
export default {"wixFee":"yBS6Dg"};